import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PartnerManager from "../admin/PartnerManager";
import QRGenerator from "../utils/QRGenerator";
import ONEboxManager from "../utils/ONEboxManager";
import "./PartnersLayout.css";

const PartnersLayout = ({ showToast, currentUser }) => {
  return (
    <div className="partners-layout">
      <div className="partners-content">
        <Routes>
          <Route path="/" element={<Navigate to="/partners/manager" replace />} />
          <Route path="/manager" element={<PartnerManager showToast={showToast} currentUser={currentUser} />} />
          <Route path="/qr-generator" element={<QRGenerator showToast={showToast} currentUser={currentUser} />} />
          <Route path="/onebox-manager" element={<ONEboxManager showToast={showToast} currentUser={currentUser} />} />
        </Routes>
      </div>
    </div>
  );
};

export default PartnersLayout;

